export const TEAM_AUGMENTATION_SERVICES = [
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/blended_teams.webp",
        header: "Blended teams",
        text: "We deeply analyze your needs and provide an expert according to your needs. Our goal is to harmoniously blend talent and expertise for successful outcomes.",
    },
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/dedicated_teams.webp",
        header: "Dedicated teams",
        text: "Our team of experts work under your supervision to develop your product. They can be assigned to separate modules of your project and take full responsibility for this part.",
    },
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/managed_teams.webp",
        header: "Managed teams",
        text: "We take full responsibility for the technical side. Our executive team consists of a Technical Director who manages developers to meet your company goals. ",
    },
]

export const CONSULTING_ADVISORY_SERVICES = [
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/it_strategy_consulting.webp",
        header: "IT strategy consulting",
        text: "We help you create a comprehensive strategy for a digital and technological transformation of your company that matches your business goals.",
    },
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/software_engineering_advisory.webp",
        header: "Software engineering advisory",
        text: "Our experts provide consultation, offering solutions to your specific needs. You can easily contact them to discuss any technical issues and explore potential resolutions.",
    },
]
